import React, { useEffect } from 'react';
import { Box, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { usePaginatedDeductionListsQuery } from '../../../../generated/graphql';
import { useWarehousesScope } from '../../../warehouse/providers/WarehouseScopeProvider';
import { NoContent, Table, TablePaginationWithCount } from '../../../../ui-kit';
import { deductionListsHeadCells } from './constants';
import DeductionListsTableContent from './DeductionListsTableContent';
import useSearchParams from './useSearchParams';


const DeductionListsTable = () => {
    const { t } = useTranslation();
    const {
        page, setPage,
        rowsPerPage, setRowsPerPage
    } = useSearchParams();
    const { currentWarehouseId } = useWarehousesScope();
    const { data, loading } = usePaginatedDeductionListsQuery({
        variables: {
            warehouseId: currentWarehouseId as string,
            offset: page,
            limit: rowsPerPage
        },
        fetchPolicy: 'cache-and-network'
    });

    useEffect(() => {
        setPage(0);
    // eslint-disable-next-line
    }, [rowsPerPage]);

    const { items: deductionLists, count } = data ? data.paginatedDeductionLists : { items: [], count: 0 };

    const tablePagination: TablePaginationWithCount = {
        onChangePage: (_, pageNumber) => setPage(pageNumber),
        currentPage: page,
        onChangeRowsPerPage: e => setRowsPerPage(parseInt(e.target.value, 10)),
        rowsPerPage,
        count,
    };

    const noContent = data ? data.paginatedDeductionLists.count === 0 : false;

    const noDeductionListTitle = t('No deduction list created');
    return noContent
        ? <NoContent title={noDeductionListTitle} />
        : (
            <Box mt={3} display='flex' flexGrow={1} style={{ overflow: 'auto' }}>
                <Grid container justify="center" alignItems="center">
                    <Grid item xs={12}>
                        <Table fixedLayout headCells={deductionListsHeadCells} isFirstColumnSticky tablePagination={tablePagination}>
                            <DeductionListsTableContent deductionLists={deductionLists} rowsPerPage={rowsPerPage} isLoading={loading} />
                        </Table>
                    </Grid>
                </Grid>
            </Box>
        );
};

export default DeductionListsTable;